import { CapoPlugin } from "/root/injective/injective-dmm-v2/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];